import React from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function MRNTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "GRN Type", field: "mrntype" },
    { label: "GRN Category", field: "mrncategory" },
    { label: "Supplier Name", field: "suppliername" },
    { label: "Purchase Order No.", field: "pono" },
    { label: "Job Number", field: "jobnumber" }, 
    { label: "GRN No.", field: "mrnno" },
    { label: "GRN Date", field: "mrndate" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"GRN"}
        apiField={"materialReceiptNote"}
        addButton={"+ ADD"}
        createRoute={"/mrnCreate"}
        updateRoute={"/mrnView"}
        viewRoute={"/mrnView"}
      />
    </div>
  );
}

export default MRNTable;
